import React from "react";
import { motion } from "framer-motion";
import { Search, FileCode2, Hammer, Rocket, ArrowRight } from "lucide-react";
import { PROCESS_STEPS } from "../lib/constants";

const ICONS = [Search, FileCode2, Hammer, Rocket];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative theme-section-alt py-24 sm:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 dot-grid opacity-30" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="flex items-center gap-3 justify-center mb-5">
            <span className="w-12 h-px bg-[#00C2FF]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.4em] text-[#00C2FF] font-bold">
              / How we work
            </span>
            <span className="w-12 h-px bg-[#00C2FF]" />
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold leading-tight tracking-tighter">
            From kickoff to launch in
            <br />
            <span className="text-gradient-cyan italic">90 days</span> — sometimes less.
          </h2>
        </motion.div>

        {/* Horizontal connector */}
        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-[#00C2FF]/40 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {PROCESS_STEPS.map((step, i) => {
              const Icon = ICONS[i] || Search;
              return (
                <motion.div
                  key={step.num}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.12, duration: 0.6 }}
                  data-testid={`process-step-${i}`}
                  className="relative group"
                >
                  {/* Step circle */}
                  <div className="relative flex items-center justify-center mb-6">
                    <div className="absolute w-32 h-32 bg-[#00C2FF]/10 rounded-full blur-2xl group-hover:bg-[#00C2FF]/30 transition-all duration-500" />
                    <div className="relative w-24 h-24 rounded-full border border-[#00C2FF]/30 bg-[#050B14] flex items-center justify-center group-hover:border-[#00C2FF] transition-all">
                      <Icon className="w-9 h-9 text-[#00C2FF]" />
                    </div>
                    <div className="absolute -top-2 -right-2 font-mono text-xs bg-[#00C2FF] text-black px-2.5 py-1 rounded-full font-bold">
                      {step.num}
                    </div>
                  </div>

                  <div className="text-center">
                    <h3 className="font-display text-xl font-bold mb-3">{step.title}</h3>
                    <p className="text-sm text-gray-400 leading-relaxed">{step.desc}</p>
                  </div>

                  {i < PROCESS_STEPS.length - 1 && (
                    <ArrowRight className="hidden lg:block absolute top-10 -right-3 w-5 h-5 text-[#00C2FF]/40" />
                  )}
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
